import React from 'react';
import { roundFloat } from 'src/core/utils/formater';
import { DeleteOutlined } from '@ant-design/icons';

const types = {
  '01': '01-Санхүүгийн дэмжлэг',
  '02': '02-Хандив',
};

export const customSummary = [
  {
    value: null,
  },
  {
    align: 'left',
    word: 'Нийт дүн:',
  },
  {
    value: null,
  },
  {
    value: null,
  },
  {
    value: null,
  },
  {
    value: null,
  },
  {
    value: null,
  },
  {
    value: null,
  },
  {
    value: null,
  },
  {
    value: null,
  },
  {
    value: null,
  },
  {
    align: 'right',
    value: 'total_dun',
  },
  {
    value: null,
  },
];

export const customColumns = ({ customDelete = () => {} }) => [
  {
    title: 'Д/Д',
    dataIndex: 'counter',
    align: 'center',
    titleAlign: 'center',
    width: 50,
  },
  {
    title: 'Төрөл',
    dataIndex: 'turul',
    align: 'center',
    titleAlign: 'center',
    width: 100,
    render: (value) => types[String(value)] || '-', // fallback to '-' if undefined
  },
  {
    title: 'Гэрээний талууд',
    titleAlign: 'center',
    children: [
      {
        title: 'Санхүүгийн дэмжлэг, хандив олгосон этгээд',
        titleAlign: 'center',
        children: [
          {
            title: 'ТТД',
            dataIndex: 'ttd_olgoson',
            align: 'left',
            titleAlign: 'center',
            width: 150,
          },
          {
            title: 'Нэр',
            dataIndex: 'ner_olgoson',
            align: 'left',
            titleAlign: 'center',
            width: 100,
          },
        ],
      },
      {
        title: 'Санхүүгийн дэмжлэг, хандив хүлээн авсан этгээд',
        titleAlign: 'center',
        children: [
          {
            title: 'ТТД',
            dataIndex: 'ttd_avsan',
            align: 'left',
            titleAlign: 'center',
            width: 150,
          },
          {
            title: 'Нэр',
            dataIndex: 'ner_avsan',
            align: 'left',
            titleAlign: 'center',
            width: 100,
          },
        ],
      },
    ],
  },
  {
    title: 'Гэрээний дугаар, төрөл',
    titleAlign: 'center',
    children: [
      {
        title: 'Огноо',
        dataIndex: 'ognoo',
        align: 'left',
        titleAlign: 'center',
        width: 100,
      },
      {
        title: 'Дугаар',
        dataIndex: 'dugaar',
        align: 'right',
        titleAlign: 'center',
        width: 150,
      },
      {
        title: 'Төрөл',
        dataIndex: 'geree_turul',
        align: 'right',
        titleAlign: 'center',
        width: 150,
      },
      {
        title: 'Зориулалт',
        dataIndex: 'geree_zoriulalt',
        align: 'right',
        titleAlign: 'center',
        width: 150,
      },
      {
        title: 'Хэрэгжих хугацаа',
        dataIndex: 'geree_hugatsaa',
        align: 'right',
        titleAlign: 'center',
        width: 150,
      },
      {
        title: 'Дүн',
        dataIndex: 'geree_dun',
        align: 'right',
        titleAlign: 'center',
        width: 150,
        render: (_, row) => ({
          children: roundFloat(row?.geree_dun),
        }),
      },
    ],
  },
  {
    title: 'Нотариатаар баталгаажуулсан эсэх',
    dataIndex: 'notariat',
    align: 'right',
    titleAlign: 'center',
    width: 150,
    render: (_, row) => ({
      children: row?.notariat === true ? 'Тийм' : 'Үгүй',
    }),
  },
  {
    title: 'Устгах',
    align: 'center',
    titleAlign: 'center',
    width: 50,
    render: (_, row) => (
      <div>
        <DeleteOutlined onClick={() => customDelete(row)} />
      </div>
    ),
  },
];
